<template>
  <div class="delete-dialog">
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="deleteCancel">
      <span>{{ text }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteCancel">取 消</el-button>
        <el-button type="primary" @click="deleteConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    props: {
      text: {
        type: String,
        default: ''
      },
      dialogVisible:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        // dialogVisible: true
      }
    },
    methods: {
      deleteCancel(){
        this.$emit('deleteCancel',false)
      },
      deleteConfirm(){
        this.$emit('deleteConfirm',true)
      }
    }
}
</script>

<style>

</style>